(function(){

var repo = createRepo();

//.............................................................................

				//module: ./umd/photoSwipeGallery
(function(define){
define(['' + resourceBuildPath + '/js/photoswipe.umd.js',
        '' + resourceBuildPath + '/js/photoswipe-ui-default.umd.js'],
    function () {

        /**
         * Listens to events from swiperSlider.
         */
        document.addEventListener('photoSwipe', (e) => handleImageSlide(e.detail));

        /**  !!! CAUTION !!!
         *  The class nomenclature contained in the modal template is imposed by the PhotoSwipe library and should not be changed.
         */
        const rootHtmlPS = `
    <div class="pswp__bg"></div>
    <div class="pswp__scroll-wrap">
        <div class="pswp-control-css"></div>
        <div class="pswp__container">
            <div class="pswp__item"></div>
            <div class="pswp__item"></div>
            <div class="pswp__item"></div>
        </div>
        <div class="pswp__ui pswp__ui--hidden">
            <div class="pswp__top-bar">
                <div class="pswp__counter"></div>
                <button class="pswp__button pswp__button--close" title="Close (Esc)"></button>
                <button class="pswp__button pswp__button--share" title="Share"></button>
                <button class="pswp__button pswp__button--fs" title="Toggle fullscreen"></button>
                <button class="pswp__button pswp__button--zoom" title="Zoom in/out"></button>
                <div class="pswp__preloader">
                    <div class="pswp__preloader__icn">
                      <div class="pswp__preloader__cut">
                        <div class="pswp__preloader__donut"></div>
                      </div>
                    </div>
                </div>
            </div>
            <div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">
                <div class="pswp__share-tooltip"></div>
            </div>
            <button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)">
            </button>
            <button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)">
            </button>
            <div class="pswp__caption">
                <div class="pswp__caption__center"></div>
            </div>
        </div>
    </div>`;

        return {
            init
        };

        /**
         * Run module
         * @param {object} domElement
         */
        function init(domElement) {
            const {
                options,
                enabledGallery,
                defaultGroupName
            } = prepareObjectInitialization(domElement);

            const lightBoxObj = new LightBox({
                runElement: domElement,
                PhotoSwipeUIDefault: PhotoSwipeUI_Default,
                options,
                enabledGallery,
                rootHtmlPS,
                defaultGroupName
            });

            const dom = lightBoxObj.init();



            require.runnerBox.runElement(dom);
        }

        /**
         * Method integration swipeSlider
         * @param {object}  domElement
         */
        function handleImageSlide(swipeSlide) {
            const domSlider = swipeSlide.closest('.ring-mini-gallery-wrapper');

            if (!domSlider) {
                return void 0;
            }

            const enabledGallery = domSlider.getAttribute('data-imagesShowArray');
            const defaultGroupName = domSlider.getAttribute('data-run-scope') || 'all';
            const imageIndex = swipeSlide.getAttribute('data-pswp-index');
            const disabledImageZoom = swipeSlide.getAttribute('data-image-zoom');

            if (disabledImageZoom === 'false') {
                require.runnerBox.runElement(domSlider);
                return;
            }

            const { options } = prepareObjectInitialization(swipeSlide);

            const lightBoxObj = new LightBox({
                runElement: domSlider,
                PhotoSwipeUIDefault: PhotoSwipeUI_Default,
                options,
                enabledGallery,
                rootHtmlPS,
                defaultGroupName
            });

            const dom = lightBoxObj.init(true, imageIndex); // set true first argument to init slider images option
            require.runnerBox.runElement(dom);
        }

        /**
         * Prepare options for lightBox
         * @param {object} domElement
         */
        function prepareObjectInitialization(domElement) {
            const options = {
                showAnimationDuration: 0,
                index: 0, //image start
                shareEl: false, //show btn share
                preload: [1, 1],
                preloaderEl: false
            };

            const enabledGallery = domElement.getAttribute('data-imagesShowArray'); // control images
            const defaultGroupName = domElement.getAttribute('data-run-scope') || 'all';

            return {
                options,
                enabledGallery,
                defaultGroupName
            };
        }
    });

/**
 * Class LightBox
 * initialization PhotoSwipe
 *
 * @constructor {}
 */
class LightBox {
    constructor({
        runElement,
        PhotoSwipeUIDefault,
        options,
        enabledGallery,
        rootHtmlPS,
        handleGroup,
        defaultGroupName
    }) {
        this.options = options;
        this.domElement = runElement;
        this.PhotoSwipeUIDefault = PhotoSwipeUIDefault;
        this.defaultIndexStart = 0;
        this.images = [];
        this.defaultSizeImages = {
            width: 800,
            height: 600
        };
        this.enabledGallery = enabledGallery;
        this.handleGroup = handleGroup || ['.mini_gallery'];
        this.defaultGroupName = defaultGroupName;
        this.groups = [];
        this.galleries = {};
        this.rootHtmlPS = rootHtmlPS;
    }

    /**
     * Initialization
     */
    init(sliderImage = false, indexImageSlide = 0) {
        this.createRunContainer();

        //if used in swipeSlider
        if (sliderImage) {
            this.images = this.createImageListSlide();
            if (this.images.length > 0) {
                this.openPhotoSwipeSlide(indexImageSlide);
            }

            return this.domElement;
        }

        this.groupMarking();
        this.images = this.createImagesList();

        return this.domElement;
    }

    /**
     * Marking gallery groups in the domElement
     * return {void}
     */
    groupMarking() {
        const conditions = this.handleGroup.join(',');
        const groups = this.domElement.querySelectorAll(conditions);

        for (const group of groups) {
            const hashGroup = Math.random().toString(36).substr(2, 9);
            const nameGroup = `group-${hashGroup}`;
            const images = group.querySelectorAll('img');

            this.groups.push(nameGroup);

            for (const image of images) {
                image.setAttribute('data-group', nameGroup);
            }
        }
    }

    /**
     * Create modal gallery container
     * @returns {void};
     */
    createRunContainer() {
        const gallery = document.createElement('div');
        gallery.classList.add('pswp');
        gallery.setAttribute('tabindex', '-1');
        gallery.setAttribute('role', 'dialog');
        gallery.setAttribute('aria-hidden', 'true');
        gallery.innerHTML = this.rootHtmlPS;

        this.domElement.appendChild(gallery);

        // Checks if the styles have been loaded
        const controlElement = this.domElement.querySelector('.pswp-control-css');
        const controlStyle = getComputedStyle(controlElement);
        if (controlStyle.opacity !== '0') {
            gallery.style.display = 'none';
            console.info('%c !! WARNING !! The default LightBox style is not loaded.\n LightBox is not running.', 'background: #8e2222; color: #fff;');
        }
    }

    /**
     * Create a gallery image list.
     * @returns {array} list images.
     */
    createImagesList() {
        const lists = [];
        //Create list images for groups
        if (this.groups.length > 0) {
            for (const group of this.groups) {
                const imagesGroupList = this.createPartialList(group);
                lists.push({
                    group,
                    images: imagesGroupList
                });
            }
        }

        const imagesNoGroup = this.createPartialList();
        lists.push({
            group: this.defaultGroupName,
            images: imagesNoGroup
        });

        return lists;
    }

    /**
     * preparation of slide photo options
     * @param {string}  url image
     * @param {string}  title image
     * @return {object|boolean}  object config of image slide or false value when error url image.
     */
    prepareItemImage(src, title = '') {
        if (!src || typeof src !== 'string') {
            return false;
        }
        return {
            src: src,
            w: 0, // image width
            h: 0, //image height
            title: title
        };
    }

    /**
     * Create slide images list.
     * @param {string} group
     * @returns {Array}  list images.
     */
    createImageListSlide() {
        const items = [],
            images = this.domElement.querySelectorAll('img');

        for (const img of images) {
            const attrSrc = img.getAttribute('data-original');
            const attrAlt = img.getAttribute('alt');
            const slide = this.prepareItemImage(attrSrc, attrAlt);
            const enabled = img.getAttribute('data-image-zoom');

            if (enabled === 'false') {
                continue;
            }

            if (slide) {
                items.push(slide);
            }

            const position = items.length - 1;
            img.classList.add('pswp-image');
            img.setAttribute('data-pswp-index', position);
        }

        return items;
    }

    /**
     * Create partial images list.
     * @param {string} group
     * @returns {Array} - list images.
     */
    createPartialList(group = null) {
        const items = [],
            images = this.domElement.querySelectorAll('img');

        for (const img of images) {
            const source = img.getAttribute('data-original');
            const groupName = img.getAttribute('data-group');
            const indexImage = img.getAttribute('data-pswp-index');
            const enabledImageZoom = img.getAttribute('data-image-zoom');

            if (indexImage || (enabledImageZoom && enabledImageZoom === 'false')) {
                continue;
            }

            //  if processing group
            if (group && typeof group === 'string') {
                if (groupName !== group) {
                    continue;
                }
            }

            if (!group && groupName) {
                continue;
            }

            if (!source) {
                continue;
            }

            const anchor = img.closest('a');
            if (anchor) {
                const isHref = anchor.getAttribute('href');

                if (isHref) {
                    continue;
                }
            }

            const attrSrc = img.getAttribute('data-original');
            const attrAlt = img.getAttribute('alt');
            const slide = this.prepareItemImage(attrSrc, attrAlt);

            if (slide) {
                items.push(slide);
            }

            const position = items.length - 1;

            img.classList.add('pswp-image');
            img.setAttribute('data-pswp-index', position);
            img.addEventListener('click', this.handleClick.bind(this), false);
        }

        return items;
    }

    /**
     * Opens the selected slide in photoSwipe.
     * @param {string} target
     */
    openPhotoSwipeSlide(target = 0) {
        this.options['index'] = parseInt(target, 10);

        if (this.enabledGallery !== 'true') {
            const selectedSlide = this.images[this.options.index];
            this.images = [];
            this.images.push(selectedSlide);
        }

        const pswpInitElement = this.domElement.querySelector('.pswp');
        const PhotoSwipeGallery = this.runPhotoSwipe(pswpInitElement, this.images);
        PhotoSwipeGallery.init();
    }

    /**
     * Launching the image / images in photoSwipe
     * @param {string} target
     */
    openPhotoSwipe(target = 0, groupImage = null) {
        if (!groupImage) {
            groupImage = this.defaultGroupName;
        }

        const pswpInitElement = this.domElement.querySelector('.pswp');
        this.options['index'] = parseInt(target, 10);

        for (const partialImages of this.images) {
            this.galleries[partialImages.group] = partialImages.images;
        }

        if (this.enabledGallery !== 'true') {
            const imagesSelect = [];
            const imagesPacked = this.galleries[groupImage];
            const image = imagesPacked[this.options.index];

            imagesSelect.push(image);
            this.galleries[groupImage] = imagesSelect;
        }

        const PhotoSwipeGallery = this.runPhotoSwipe(pswpInitElement, this.galleries[groupImage]);
        PhotoSwipeGallery.init();
    }

    /**
     * Initialization PhotoSwipe Object
     * @param {object}  DOM Object
     * @param {Array}  images list
     * @returns {object} PhotoSwipeObject
     */
    runPhotoSwipe(pswpInitElement, partialImages) {
        const photoSwipeObj = new PhotoSwipe(pswpInitElement,
            this.PhotoSwipeUIDefault,
            partialImages,
            this.options);
        photoSwipeObj.listen('gettingData', function (index, item) {
            if (item.w < 1 || item.h < 1) {
                const img = new Image();
                img.onload = function () {
                    item.w = this.width || this.defaultSizeImages.width;
                    item.h = this.height || this.defaultSizeImages.height;
                    item.needsUpdate = true;
                    photoSwipeObj.updateSize(true);
                };
                img.src = item.src;
            }
        });
        return photoSwipeObj;
    }

    /**
     * Handle event clock method
     * @param {object} - event
     */
    handleClick(e) {
        const targetImage = e.target.getAttribute('data-pswp-index');
        const groupImage = e.target.getAttribute('data-group') || this.defaultGroupName;

        this.openPhotoSwipe(targetImage, groupImage);
    }
}

}(repo.getDefine("./umd", "photoSwipeGallery")));

//.............................................................................

				//module: ./photoSwipeGallery
(function(define){
define([
    './umd/photoSwipeGallery',
], function (
    photoSwipeGallery
) {
    return {
        photoSwipeGallery: photoSwipeGallery.init,
    };
});
}(repo.getDefine(".", "photoSwipeGallery")));

//.............................................................................

repo.install("./photoSwipeGallery");

//.............................................................................

function createRepo() {

    var isInstall = false;
    //moduły zewnętrzne
    var modulesExt = createModulesExt();
    //moduły lokalne
    var modules = {};

    return {
        getDefine: getDefine,
        install: install
    };

    function getDefine(path, name) {

        return function(deps, def) {

            if (isInstall === false) {

                modules[path + '/' + name] = createEvalModule(path, deps, def);

            } else {

                throw Error('You cannot define module after configuration process');
            }
        };
    }

    function createEvalModule(path, deps, def) {

        var moduleObject = null;

        addToExt(deps);

        return {
            'get': get
        };

        function get(extModuleObj) {

            if (moduleObject === null) {
                moduleObject = createModuleObject(extModuleObj);
            }

            return moduleObject;
        }

        function createModuleObject(extModuleObj) {

            var depsResolve = [];

            for (var i = 0; i < deps.length; i++) {
                depsResolve.push(resolve(deps[i]));
            }

            return def.apply(null, depsResolve);

            function resolve(moduleName) {

                if (isModuleLocal(moduleName)) {

                    return getLocal(moduleName);

                } else {

                    return getExtends(moduleName);
                }
            }

            function getExtends(moduleName) {

                if (moduleName in extModuleObj) {
                    return extModuleObj[moduleName];
                } else {
                    throw Error('There is no definition for external module: ' + moduleName);
                }
            }

            function getLocal(moduleName) {

                var modulePath = path + '/' + moduleName;
                var out;

                var modulePathNormalize = normalizePath(modulePath);

                if (typeof(modulePathNormalize) === 'string' && modulePathNormalize !== '') {

                    out = getFromModules(modulePathNormalize);

                    if (out !== null) {
                        return out;
                    } else {
                        throw Error('There is no definition for module: ' + modulePathNormalize);
                    }

                } else {

                    throw Error('There is a problem with path normalization: ' + modulePath);
                }

                function getFromModules(moduleFullName) {

                    var value = modules[moduleFullName];

                    if (typeof(value) !== 'undefined') {
                        return value.get(extModuleObj);
                    } else {
                        return null;
                    }
                }
            }
        }
    }

    function normalizePath(path) {

        var chunks = path.split('/');

        var newChunks = [];

        for (var i = 0; i < chunks.length; i++) {

            var value = chunks[i];

            if (value === '.') {

                if (newChunks.length === 0) {

                    newChunks.push(value);

                } else {

                    //ignoruj znak
                }

            } else if (value === '..') {

                if (newChunks.length >= 2) {

                    newChunks.pop();

                } else {

                    return null;
                }

            } else {

                newChunks.push(value);
            }
        }

        return newChunks.join('/');
    }

    function addToExt(deps) {

        for (var i = 0; i < deps.length; i++) {
            add(deps[i]);
        }

        function add(moduleName) {

            if (isModuleLocal(moduleName)) {

            } else {

                modulesExt.addName(moduleName);
            }
        }
    }

    function isModuleLocal(moduleName) {

        if (typeof(moduleName) === 'string') {

            if (moduleName.length >= 2 && moduleName.substr(0, 2) === './') {
                return true;
            } else if (moduleName.length >= 3 && moduleName.substr(0, 3) === '../') {
                return true;
            } else {
                return false;
            }

        } else {

            throw Error('Module name should be string');
        }
    }

    function getModule(name, extModuleObj) {

        if (typeof(modules[name]) !== 'undefined') {
            return modules[name].get(extModuleObj);
        } else {
            throw Error('Module not defined: ' + name);
        }
    }

    //instalowanie zewnętrznej końcówki odnoszącej się do requirejs (która pobierze zewnętrzne moduły)
    function install(mainModule) {

        if (isInstall === false) {

            isInstall = true;

            define(modulesExt.getModulesName(), function() {

                //konwersja "arguments" na tablicę
                var copyParams = Array.prototype.slice.call(arguments, 0);

                //potrzebne do evaluowania ...
                var moduleObj = modulesExt.getExtendsModulesObject(copyParams);

                //ewaluowanie głównego modułu - z podmodułami jeśli trzeba
                return getModule(mainModule, moduleObj);
            });

        } else {

            throw Error('Unsupported state');
        }
    }

    function createModulesExt() {

        var isSet = false;

        var modulesName = [];
        var modulesExtValue = {};

        return {
            'addName': addName,
            'getExtendsModulesObject': getExtendsModulesObject,
            'getModulesName': getModulesName
        };

        function getExtendsModulesObject(modules) {

            if (modulesName.length === modules.length) {

                return getObj();

            } else {

                throw Error('Unsupported state');
            }

            function getObj() {

                var out = {};

                for (var i = 0; i < modulesName.length; i++) {
                    setOut(modulesName[i], modules[i]);
                }

                return out;

                function setOut(name, value) {
                    out[name] = value;
                }
            }
        }

        function getModulesName() {

            return modulesName;
        }

        function addName(name) {

            if (isSet === false) {

                if (isNoEmptyString(name)) {

                    if (typeof(modulesExtValue[name]) !== 'string') {

                        modulesExtValue[name] = name;
                        modulesName.push(name);
                    }

                } else {

                    throw Error('Unsupported parameter type');
                }

            } else {

                throw Error('Unsupported state');
            }
        }
    }

    function isNoEmptyString(value) {

        return (typeof(value) === 'string' && value !== '');
    }
}


//.............................................................................

}());